import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFocusSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFocusSquare"><Path d="M3 3H8.75V4.5H4.5V8.75H3V3Z" fill="currentColor"/><Path d="M15.25 3H21V8.75H19.5V4.5H15.25V3Z" fill="currentColor"/><Path d="M4.5 15.25V19.5H8.75V21H3V15.25H4.5Z" fill="currentColor"/><Path d="M21 15.25V21H15.25V19.5H19.5V15.25H21Z" fill="currentColor"/><Path d="M16 8H8V16H16V8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFocusSquare;
